import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Ratings extends Component {

    render () {
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-12 text-center">
                                <h1 className="color-grey capitalize">Rating</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    {/* START: Breadcrumb Component */}
                    <ul className="breadcrumb">
                        <li><Link to='/user-relationship/users'>User Management</Link></li>
                        <li><Link to='/user-relationship/users/id'>Single User</Link></li>
                        <li>Rating</li>
                    </ul>
                    {/* END: Breadcrumb Component */}
                </div>
                <div className="container box inner-padding mb-15">
                    <div className="box-body flex col-xs-9">
                        <ul className="ratings">

                            <li className="pb-30">
                                <div className="flex wrap align-center">
                                    <ul className="stars mr-25">
                                        <li><i className="fa fa-star"></i></li>
                                        <li><i className="fa fa-star"></i></li>
                                        <li><i className="fa fa-star"></i></li>
                                        <li><i className="fa fa-star"></i></li>
                                        <li><i className="fa fa-star deactive"></i></li>
                                    </ul>
                                    <p className="color-grey50 w-600 font-sm">25.05.19</p>

                                </div>
                                <p className="py-10">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium alias culpa cumque dicta dolor, dolorem dolores et libero optio perferendis placeat quibusdam quidem quo rerum saepe. Ipsam laborum magni rem.</p>
                                <div className="flex justify-between align-center">
                                    <ul className="w-700 flex">
                                        <li className="mr-20 color-primary font-normal"><span className="font-sm color-grey50 mr-5">Driver Name: </span>Abd al Jabbar</li>
                                        <li className="mr-20 color-primary font-normal"><span className="font-sm color-grey50 mr-5">Order Id: </span>521431544</li>
                                    </ul>

                                </div>
                            </li>
                            <li>
                                <div className="flex wrap align-center">
                                    <ul className="stars mr-25">
                                        <li><i className="fa fa-star"></i></li>
                                        <li><i className="fa fa-star"></i></li>
                                        <li><i className="fa fa-star"></i></li>
                                        <li><i className="fa fa-star"></i></li>
                                        <li><i className="fa fa-star deactive"></i></li>
                                    </ul>
                                    <p className="color-grey50 w-600 font-sm">25.05.19</p>

                                </div>
                                <p className="py-10">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium alias culpa cumque dicta dolor, dolorem dolores et libero optio perferendis placeat quibusdam quidem quo rerum saepe. Ipsam laborum magni rem.</p>
                                <div className="flex justify-between align-center">
                                    <ul className="w-700 flex">
                                        <li className="mr-20 color-primary font-normal"><span className="font-sm color-grey50 mr-5">Driver Name: </span>Abd al Jabbar</li>
                                        <li className="mr-20 color-primary font-normal"><span className="font-sm color-grey50 mr-5">Order Id: </span>521431544</li>
                                    </ul>

                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Ratings;



// WEBPACK FOOTER //
// ./src/components/User-relationship/Ratings.js